import { render } from "./App.vue?vue&type=template&id=32cbfa6c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=32cbfa6c&scoped=true&lang=css"

import exportComponent from "/Users/jamieplamb/Dropbox/Jamie - Documents/TotalParkingSolutions/Apps/TPSWhitelister/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cbfa6c"]])

export default __exports__